import React from 'react';
import { Mail, Phone, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: '#0f172a',
      color: '#ffffff',
      padding: '3rem 1.5rem 1.5rem',
    }}>
      <div style={{
        maxWidth: '1280px',
        margin: '0 auto',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem',
        }}>
          {/* Company Info */}
          <div>
            <span style={{
              fontFamily: '"Zalando Sans Expanded", sans-serif',
              fontSize: '1.75rem',
              fontWeight: 900,
              color: '#ECEC75',
              marginBottom: '1rem',
            }}>
              NO 
            </span>
            <span style={{
              fontFamily: '"Zalando Sans Expanded", sans-serif',
              fontSize: '1.75rem',
              fontWeight: 450,
              color: '#ECEC75',
              marginBottom: '1rem',
            }}>
              MOISTURE
            </span>
            <p style={{
              fontSize: '0.875rem',
              color: '#94a3b8',
              lineHeight: 1.6,
              marginBottom: '1rem',
            }}>
              NOMOISTURE supplies high-absorption calcium chloride desiccant bags and silica gel
              pouches for export cargo moisture protection, container rain prevention and humidity
              control across ocean freight shipping worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#ECEC75',
              marginBottom: '1rem',
            }}>
              Quick Links
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
            }}>
              {['home', 'about', 'products', 'faq', 'contact'].map((item) => (
                <li key={item} style={{ marginBottom: '0.5rem' }}>
                  <button
                    onClick={() => {
                      const element = document.getElementById(item);
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#94a3b8',
                      fontSize: '0.875rem',
                      cursor: 'pointer',
                      padding: 0,
                      textTransform: 'capitalize',
                      transition: 'color 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#ECEC75';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#94a3b8';
                    }}
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#ECEC75',
              marginBottom: '1rem',
            }}>
              Contact Us
            </h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
            }}>
              <a 
                href="mailto:nomoisture@gmail.com"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#94a3b8',
                  fontSize: '0.875rem',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#ECEC75';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#94a3b8';
                }}
              >
                <Mail size={16} />
                nomoisture@gmail.com
              </a>
              <a 
                href="tel:+917710034766"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#94a3b8',
                  fontSize: '0.875rem',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#ECEC75';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#94a3b8';
                }}
              >
                <Phone size={16} />
                +91 77100 34766
              </a>
              <div style={{
                display: 'flex',
                gap: '0.75rem',
                marginTop: '0.5rem',
              }}>
                <a
                  href="https://linkedin.com/company/nomoisture"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#94a3b8',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#ECEC75';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#94a3b8';
                  }}
                >
                  <Linkedin size={20} />
                </a>
               
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid #1e293b',
          paddingTop: '1.5rem',
          textAlign: 'center',
        }}>
          <p style={{
            fontSize: '0.875rem',
            color: '#64748b',
            margin: 0,
          }}>
            © {currentYear} No Moisture. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
